export type Role = 'admin' | 'editor' | 'viewer';

export const getRole = (): Role => (localStorage.getItem('role') as Role) || 'viewer';
export const canEdit = (): boolean => ['admin', 'editor'].includes(getRole());
export const isAdmin = (): boolean => getRole() === 'admin';
